var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
        'btn-primary': _vm.variant === 'primary',
        'btn-secondary': _vm.variant === 'secondary',
        'btn-outline-dark': _vm.variant === 'outline-dark',
        outline:
            _vm.variant === 'outline-primary' ||
            _vm.variant === 'outline-secondary',
        'outline-primary': _vm.variant === 'outline-primary',
        'outline-secondary': _vm.variant === 'outline-secondary',
        'text-primary': _vm.variant === 'text-primary',
        'text-secondary': _vm.variant === 'text-secondary',
        'text-error': _vm.variant === 'text-error',
        disabled: _vm.disabled === true,
        'tiny-btn': _vm.tiny === true,
        'extended-btn': _vm.extended === true,
        'no-outline': _vm.outline === false,
    },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(!_vm.disabled || !_vm.disabledHint)?_vm._t("default"):[_vm._v(_vm._s(_vm.disabledHint))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }